import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { persistFirestoreListenDebugFromUrl } from './utils/firestoreListenDebug';
import { installConsoleLogBuffer } from './utils/consoleLogBuffer';

persistFirestoreListenDebugFromUrl();
installConsoleLogBuffer();

/** Benign browser noise — CRA dev overlay treats it as fatal; not an app bug. */
const RESIZE_OBSERVER_LOOP =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

function isResizeObserverLoopError(message: unknown): boolean {
  return typeof message === 'string' && RESIZE_OBSERVER_LOOP.test(message);
}

function installResizeObserverLoopGuard(): void {
  window.addEventListener(
    'error',
    event => {
      const message = event.message || (event.error as Error | undefined)?.message;
      if (isResizeObserverLoopError(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  // Defer RO callbacks so layout reads/writes don't re-enter in the same frame (React Flow, etc.).
  const NativeResizeObserver = window.ResizeObserver;
  if (!NativeResizeObserver) return;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

installResizeObserverLoopGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
